exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".callout-panel {\n  margin: 30px 0;\n  text-align: center; }\n\n.callout-panel-icon {\n  color: #4285f4;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 20px; }\n\n.callout-panel-icon i {\n  font-size: 80px;\n  margin-top: 10px; }\n\n.callout-message {\n  font-size: 16px;\n  text-transform: uppercase;\n  margin-bottom: 40px; }\n\n.input-container {\n  margin: 0 30px;\n  padding: 0; }\n  .input-container .input-field {\n    border: 1px solid #b2b2b2;\n    padding: 0 10px;\n    font-size: 1rem;\n    height: 33px;\n    width: 93% !important;\n    margin-left: -5px;\n    text-align: center; }\n\n.button-container {\n  padding-top: 50px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/project-overview/components/create-project/create-project.component.scss
// module id = 1295
// module chunks = 0